export default function (Vue, parent, _data) {
  var node_circular = {
    template: `
    <div class='__config__body'> 
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item title="基本属性" name="1">
           <el-form  label-width="65px">
            <el-form-item label="唯一标识：" v-show=false>
                <el-input v-model="data['id']" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="节点名称：">
                <el-input v-model="data['name']" :disabled="!params.editable"></el-input>
            </el-form-item>
            <el-form-item label="节点序号：">
                <el-input v-model="data['sn']"></el-input>
            </el-form-item>
            </el-form>
        </el-collapse-item>
        <el-collapse-item title="流程控制" name="2">
           <el-form label-width="92px">
            <el-form-item label="节点类型：">
                <el-select @change='changeType' v-model="data['type']" :disabled="!params.editable">
                  <el-option
                    v-for="item in types"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="办理部门：">
                <el-select v-model="data['groupType']">
                  <el-option
                    v-for="item in groupTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="相对部门：" v-show="data['groupType'] === 'relative' ">
                <el-input v-model="data['relativeGroupName']" style="width:60%;" :disabled="true"></el-input>
                <el-button type="primary" @click="showDept">选择</el-button>
            </el-form-item>
             <el-form-item label="相对部门" v-show="false">
                  <el-input v-model="data['relativeGroup']" :disabled="true"></el-input>
              </el-form-item>
            <el-form-item label="部门字段："  v-show="data['groupType'] === 'biz' ">
                <el-input v-model="data['groupField']"></el-input>
            </el-form-item>
            <el-form-item label="部门经办节点：" v-show="data['groupType'] === 'handled-group' ">
                <el-input v-model="data['groupHandledActName']"  :disabled="true" style="width:60%;"></el-input>
                <el-button type="primary" @click="showHandledNode({id:'groupHandled', name:'groupHandledActName'})">选择</el-button>
            </el-form-item>
            <el-form-item label="部门经办节点" v-show="false">
                  <el-input v-model="data['groupHandled']" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="部门范围：">
                <el-select v-model="data['group']">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="办理用户：">
                <el-select v-model="data['userType']">
                  <el-option
                    v-for="item in userTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="用户权限：" v-show="data['userType'] === 'role' ">
              <el-input v-model="data['userRoleName']" style="width:60%" :disabled="true"></el-input>
              <el-button type="primary" @click="showRole({id:'userRole', name:'userRoleName'})">选择</el-button>
            </el-form-item>
            <el-form-item label="用户权限" v-show="false">
              <el-input v-model="data['userRole']" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="用户字段：" v-show="data['userType']=== 'biz' ">
                <el-input v-model="data['userField']"></el-input>
            </el-form-item>
            <el-form-item label="用户经办节点：" v-show="data['userType'] === 'handled-user' ">
                <el-input v-model="data['userHandledActName']"  :disabled="true" style="width:60%"></el-input>
                <el-button type="primary" @click="showHandledNode({id:'userHandled', name:'userHandledActName'})">选择</el-button>
            </el-form-item>
            <el-form-item label="用户经办节点" v-show="false">
                  <el-input v-model="data['userHandled']" :disabled="true"></el-input>
              </el-form-item>
            <el-form-item label="排除条件：">
              <el-radio-group v-model="data['excludeSwitch']" size="mini">
                <el-radio-button label="1">开</el-radio-button>
                <el-radio-button label="0">关</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="排除范围：" v-show="data['excludeSwitch']== '1' ">
                <el-select v-model="data['excludeType']">
                  <el-option
                    v-for="item in excludeTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-form>
        </el-collapse-item>
        <el-collapse-item title="表单控制" name="3">
           <el-form  label-width="92px">
            <el-form-item label="操作按钮：">
                <el-button type="primary" @click="showFlowButton()">选择</el-button>
            </el-form-item>
            <div style="padding:5px;border:1px #ddd solid" v-show="data.buttons.length>0">
              <el-button  :key="button.id" v-for="button in data.buttons">{{button.name}}
              </el-button>
            </div>
            <el-form-item label="操作权限：">
                <el-button type="primary" @click="showFormOperAuth()">选择</el-button>
            </el-form-item>
             <div style="padding:5px;border:1px #ddd solid" v-show="data.operAuths.length>0">
                 <el-button  :key="auth.id" v-for="auth in data.operAuths">{{auth.name}}
                 </el-button>
            </div>
             <el-form-item label="切换表单：">
                <el-button type="primary" @click="showRelateForm()">选择</el-button>
               </el-form-item>
               <div style="padding:5px;border:1px #ddd solid" v-show="data.openFormId">
                   <div v-text="data.openFormName"></div>
            </div>
           <el-form-item label="启用传阅：">
              <el-radio-group v-model="data['circularSwitch']" size="mini">
                <el-radio-button label="1">开</el-radio-button>
                <el-radio-button label="0">关</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="传阅范围：" v-show="data['circularSwitch']==='1'">
                <el-select v-model="data['circularScope']">
                  <el-option
                    v-for="item in circularScopes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="传阅秘书代办："  v-show="data['circularSwitch']==='1'">
                <el-radio-group v-model="data['circularSecretarySwitch']">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
                </el-radio-group>
               </el-form-item>
               <el-form-item label="秘书节点名：" v-show="data['circularSwitch']==='1' && data['circularSecretarySwitch']==='1'">
                    <el-input v-model="data['circularSecActivityName']"></el-input>
                </el-form-item>
                <el-form-item label="领导节点名：" v-show="data['circularSwitch']==='1' && data['circularSecretarySwitch']==='1'">
                    <el-input v-model="data['circularLeaderActivityName']"></el-input>
                </el-form-item>
                <el-form-item label="默认意见：">
                    <el-input v-model="data['defaultComment']"></el-input>
                </el-form-item>
               <el-form-item label="只读:" >
                  <el-radio-group v-model="data['readOnly']" size="mini">
                    <el-radio-button label="1">开</el-radio-button>
                    <el-radio-button label="0">关</el-radio-button>
                  </el-radio-group>
               </el-form-item>
                <el-form-item label="附件可编辑:" >
                  <el-radio-group v-model="data['editAttach']" size="mini">
                    <el-radio-button label="1">开</el-radio-button>
                    <el-radio-button label="0">关</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="附件可上传:" >
                  <el-radio-group v-model="data['uploadAttach']" size="mini">
                    <el-radio-button label="1">开</el-radio-button>
                    <el-radio-button label="0">关</el-radio-button>
                  </el-radio-group>
                </el-form-item> 
                <el-form-item label="附件可下载:" >
                  <el-radio-group v-model="data['downloadAttach']" size="mini">
                    <el-radio-button label="1">开</el-radio-button>
                    <el-radio-button label="0">关</el-radio-button>
                  </el-radio-group>
                </el-form-item> 
                <el-form-item label="正文打开方式:" >
                    <el-input v-model="data['attchOct']" style="width:calc(100% - 48px);"></el-input>
                    <el-button type="primary" @click="showOcxList">选择</el-button>
                </el-form-item> 
            </el-form>
        </el-collapse-item>
        <el-collapse-item title="秘书代办" name="4">
            <el-form  label-width="92px">
              <el-form-item label="启用秘书代办：">
                <el-radio-group v-model="data['secretarySwitch']">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
                </el-radio-group>
               </el-form-item>
               <el-form-item label="秘书节点名：" v-show="data['secretarySwitch']==='1'">
                    <el-input v-model="data['secActivityName']"></el-input>
                </el-form-item>
                <el-form-item label="领导节点名：" v-show="data['secretarySwitch']==='1'">
                    <el-input v-model="data['leaderActivityName']"></el-input>
                </el-form-item>
              </el-form>  
         </el-collapse-item>
         <el-collapse-item title="移动配置" name="6">
          <el-form  label-width="92px">
              <el-form-item label="是否办理:" >
                  <el-radio-group v-model="data['mobileHandler']" size="mini">
                    <el-radio-button label="1">开</el-radio-button>
                    <el-radio-button label="0">关</el-radio-button>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="表单编辑:" >
                  <el-radio-group v-model="data['mobileEdit']" size="mini">
                    <el-radio-button label="1">开</el-radio-button>
                    <el-radio-button label="0">关</el-radio-button>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="编辑正文:" >
                  <el-radio-group v-model="data['mobileZWEdit']" size="mini">
                    <el-radio-button label="1">开</el-radio-button>
                    <el-radio-button label="0">关</el-radio-button>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="编辑附件:" >
                  <el-radio-group v-model="data['mobileFJEdit']" size="mini">
                    <el-radio-button label="1">开</el-radio-button>
                    <el-radio-button label="0">关</el-radio-button>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="上传附件:" >
                  <el-radio-group v-model="data['mobileFJUpload']" size="mini">
                    <el-radio-button label="1">开</el-radio-button>
                    <el-radio-button label="0">关</el-radio-button>
                  </el-radio-group>
              </el-form-item>
          </el-form-item>
          </el-form>
        </el-collapse-item>
         <el-collapse-item title="其他" name="5">
           <el-form  label-width="92px">
            <el-form-item label="执行脚本：">
                <el-button type="primary" @click="showFlowScriptSet('node')">设置</el-button>
            </el-form-item>
            <el-form-item label="是否领导节点：">
              <el-select v-model="data['leaderNode']">
                  <el-option
                    v-for="item in groupYesNo"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            </el-form>
        </el-collapse-item>     
      </el-collapse>
      </div>
    `,
    props: {
      data: {
        type: Object
      },
      params:{
        type: Object
      }
    },
    data() {
      return {
        fields:['id','name','type','sn','groupType','group','relativeGroup', 'relativeGroupName',
          'groupField','groupHandled','groupHandledActName','userType','userRole','userRoleName','userField','userHandledActName',
          'userHandled','excludeSwitch','excludeType','buttons','scriptActions','operAuths', 'defaultComment',
          'circularSwitch','circularScope','circularSecretarySwitch','circularSecActivityName','circularLeaderActivityName',
          'secretarySwitch','secActivityName','leaderActivityName','openFormId','openFormName','leaderNode',
          'mobileHandler','mobileEdit','mobileZWEdit','mobileFJEdit','mobileFJUpload',
          'readOnly','editAttach','uploadAttach','downloadAttach','attchOct','attchOctKey'],

        activeName: '1',
        types:[],

        groupTypes:[{value:'role',label:'权限'},{value:'relative',label:'相对部门'},{value:'handled-group',label:'经办'},{value:'biz',label:'业务指定'},{value:'upper-group',label:'发送部门'},{value:'draft-group',label:'发起部门'}],

        groups:[{value:'<当前>', label:'<当前>'},{value:'<上级>', label:'<上级>'}, {value:'<下级>', label:'<下级>'}, {value:'<平级>', label:'<平级>'},
          {value:'<当前和上级>', label:'<当前和上级>'},{value:'<当前和下级>', label:'<当前和下级>'},
          {value:'<所有下级>', label:'<所有下级>'}, {value:'<上级的平级>', label:'<上级的平级>'},
          {value:'<本部门任选>', label:'<本部门任选>'},{value:'<部门上级>', label:'<部门上级>'}, {value:'<部门下级>', label:'<部门下级>'}, {value:'<部门平级>', label:'<部门平级>'},
          {value:'<本单位任选>', label:'<本单位任选>'},{value:'<本单位任选(不包含下级)>', label:'<本单位任选(不包含下级)>'},
          {value:'<本单位的一级部门>', label:'<本单位的一级部门>'},{value:'<单位上级>', label:'<单位上级>'},{value:'<单位平级>', label:'<单位平级>'},
          {value:'<上级单位部门>', label:'<上级单位部门>'},{value:'<上级单位任选>', label:'<上级单位任选>'}/*, {value:'<任选>', label:'<任选>'}*/],
        userTypes:[{value:'role',label:'权限'}, {value:'handled-user',label:'经办'},{value:'biz',label:'业务指定'},{value:'draft-user',label:'发起人'},{value:'upper-user',label:'发送人'}],
        circularScopes:[{value:'<当前>', label:'<当前>'},{value:'<本部门任选>', label:'<本部门任选>'}, {value:'<本单位任选>', label:'<本单位任选>'},{value:'<任选>', label:'<任选>'}],
        excludeTypes:[{value:'current-user', label:'当前用户'},{value:'current-dep', label:'当前部门'}],
        groupYesNo:[{value:'1', label:'是'},{value:'0', label:'否'}]
      };
    },
    created() {
      let me=this;
      me.clearField();
      me.types=me.params.activityTypes;
      me.initData();
    },
    watch: {
      'data.name': function (val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", {id: me.data.id, name: val})
        }
      },
      'data.id': function (val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name
          this.$set(this.data, 'name', '新增节点')
        }
        this.initData();
      }
    },
    methods: {
      initData(){
        var me = this;
        if(this.data.openFormId == undefined){
          this.$set(this.data, 'openFormId', '');
          this.$set(this.data, 'openFormName', '');
        }
        //this.$set(this.data, 'multipleUnit', '1');
        if(me.data.name == undefined) {
          this.$set(me.data, 'name', '新增节点')
        }
        if(this.data.excludeSwitch == undefined){
          this.$set(this.data, 'excludeSwitch', '0');
        }
        if(this.data.mobileHandler == undefined){
          this.$set(this.data, 'mobileHandler', "1");
        }
        if(this.data.mobileEdit == undefined){
          this.$set(this.data, 'mobileEdit', "0");
        }
        if(this.data.mobileZWEdit == undefined){
          this.$set(this.data, 'mobileZWEdit', "0");
        }
        if(this.data.mobileFJEdit == undefined){
          this.$set(this.data, 'mobileFJEdit', "0");
        }
        if(this.data.mobileFJUpload == undefined){
          this.$set(this.data, 'mobileFJUpload', "1");
        }
        if(this.data.readOnly == undefined){
          this.$set(this.data, 'readOnly', "0");
        }
        if(this.data.editAttach == undefined){
          this.$set(this.data, 'editAttach', "1");
        }
        if(this.data.uploadAttach == undefined){
          this.$set(this.data, 'uploadAttach', "1");
        }
        if(this.data.downloadAttach == undefined){
          this.$set(this.data, 'downloadAttach', "1");
        }
        if(this.data.attchOctKey == undefined){
          this.$set(this.data, 'attchOctKey', "");
        }
        if(this.data.attchOct == undefined){
          this.$set(this.data, 'attchOct', "无");
        }
        if(this.data.buttons == undefined){
          this.$set(this.data, 'buttons', []);
        }
        if(this.data.scriptActions == undefined){
          this.$set(this.data, 'scriptActions', {});
        }
        if(this.data.operAuths == undefined){
          this.$set(this.data, 'operAuths', []);
        }
        if(this.data.type == undefined){
          this.$set(this.data, 'type', 'circular');
        }

        if(this.data.groupType == undefined){
          this.$set(this.data, 'groupType', this.groupTypes[0].value);
        }

        if(this.data.group == undefined){
          this.$set(this.data, 'group', '<当前>');
        }

        if(this.data.userType == undefined){
          this.$set(this.data, 'userType', this.userTypes[0].value);
        }
        if(this.data.circularSwitch == undefined){
          this.$set(this.data, 'circularSwitch', '0');
        }
        if(this.data.circularScope == undefined){
          this.$set(this.data, 'circularScope', this.circularScopes[0].value);
        }
        if(this.data.circularSecretarySwitch == undefined){
          this.$set(this.data, 'circularSecretarySwitch', '0');
        }
        if(this.data.excludeType == undefined){
          this.$set(this.data, 'excludeType', this.excludeTypes[0].value);
        }

        if(this.data.secretarySwitch == undefined){
          this.$set(this.data, 'secretarySwitch', '0');
        }
        if(this.data.leaderNode == undefined){
          this.$set(this.data, 'leaderNode', '0');
        }
      },

      showRelateForm(){
        var me  = this;
        var moduleId = me.params.moduleId;
        var appId = me.params.applicationId;

        PF.show('tableDialog', {api:"app.listModuleForm",clearBtn:true,
          defaultParams:{moduleId:moduleId, appId:appId},singleSelect:true}, function (res) {
          if(res.length>0){
            me.$set(me.data,'openFormId',res[0].id);
            me.$set(me.data,'openFormName',res[0].name);
          }else{
            me.$set(me.data,'openFormId',"");
            me.$set(me.data,'openFormName',"");
          }
        });

      },
      showOcxList(){
        let me=this;
        PF.show('tree',{url: me.mwUrl("/api/data/getOcxList"), selectFirst:false,selectNode:"", search:true, async:true, singleLeaf:true},function(res){
          me.$set(me.data,'attchOct',res.name||"");
          me.$set(me.data,'attchOctKey',res.key||"");
        });
      },
      showHandledNode(f){
        var me =  this;
        var selectNode = '';
        if(me.data[f.id]){
          selectNode = me.data[f.id];
        }
        PF.show('tree',{treeData:me._getActivities(['start','end','circular','sub-proc']), selectFirst:false, selectNode:selectNode},function(res){
          me.$set(me.data,f.id,res.id);
          me.$set(me.data,f.name,res.name);
        });

      },
      showDept(){
        var me  = this;
        var selectNode = '';
        if(me.data['relativeGroup']){
          selectNode = me.data['relativeGroup'];
        }
        PF.show('tree',{url: this.mwUrl("/api/org/listDepartment"), selectFirst:false,selectNode:selectNode, search:true, async:true, singleLeaf:false},function(res){
          me.$set(me.data,'relativeGroup',res.id);
          me.$set(me.data,'relativeGroupName',res.name);
        });
      },
      showRole(f){
        var me  = this;
        var selectNode = '';
        if(me.data[f.id]){
          selectNode = me.data[f.id];
        }
        //
        PF.show('tree',{url: this.mwUrl("/api/org/listFlowGroupedRole"),selectFirst:false, selectNode:selectNode, search:true,clearBtn:true},function(res){
          me.$set(me.data,f.id,res.id);
          me.$set(me.data,f.name,res.name);
        });
      },
      showFlowButton(){
        var me  = this;
        var value=[];
        for(var i=0;i<me.data.buttons.length;i++){
          value.push(me.data.buttons[i].action);
        }
        PF.show('treeTable', {
          url: me.mwUrl("/api/app/listActionComponentByTypeTree"),treeDefaultParams: {type: "系统分类/表单/流程",flag:0}
          ,size: 'small_large',
          selectFirst: true,asyncLoadOnce:true,clearBtn: true, title: '选择动作脚本', changed: function (data) {
            let me = this;
            me.defaultParams = {type: data.code, flag:2};
          }, api: 'app.getAllButton', singleSelect: false
        }, function (res) {
          let btns=[];
          if (res && res.length > 0) {
            res.forEach(v=>{
              if(v.action){
                btns.push({name:v.name,action:v.action});
              }
            })
          }
          me.$set(me.data,'buttons',btns);
        });
      },
      showFlowScriptSet(type){
        var me = this;
        var p = {};
        p.type = type;
        var scriptActions = me.data.scriptActions;
        if(scriptActions){
          p.scriptActions = scriptActions;
        }else{
          p.scriptActions ={};
        }
        PF.show('flowScriptSet',p,function(res){
          me.$set(me.data,'scriptActions',res);
        })
      },
      showFormOperAuth(){
        var me  = this;
        var moduleId = me.params.moduleId;
        var appId = me.params.applicationId;
        var checkNodes=[];
        for(var i=0;i<me.data.operAuths.length;i++){
          checkNodes.push(me.data.operAuths[i].id);
        }
        PF.show('tree', {url: this.mwUrl
        ("/api/app/listModuleFormOperAuthTree"), checkNodes:checkNodes,search:
          true,multiple:true,singleLeaf:false,clearBtn:true,multipleLeaf:false,
          defaultParams:{moduleId:moduleId, appId:appId}}, function (res) {
          let auths=[];
          if (res && res.length > 0) {
            res.forEach(v=>{
              if(v.id){
                auths.push({name:v.name,id:v.id});
              }
            })
          }
          me.$set(me.data,'operAuths',auths);
        });
      },
      clearField:function(){
        var me=this;
        function contains(obj) {
          for(var i=0;i<me.fields.length;i++){
            if(me.fields[i]==obj){
              return true
            }
          }
          return false;
        }
        var del=[]
        for(var s in me.data){
          if(!contains(s)){
            del.push(s)
          }
        }
        for(var i=0;i<del.length;i++){
          delete me.data[del[i]]
        }
      },
      changeType:function(val){
        parent.$emit("updateShape", {id: this.data.id, type: val})
        this.params.changeType(val);
      },
      _getActivities(excludeActivityTypes){
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var treeData = [];
        var exclude;
        activities.forEach(a=>{
          exclude = false;
          excludeActivityTypes.forEach(et=>{
            if(et==a.extends){
              exclude = true;
            }
          });
          if(!exclude){
            treeData.push({id:a.id, text:a.parameters.name, name:a.parameters.name});
          }
        });
        return treeData;
      }
    }
  }
  return node_circular
}



// WEBPACK FOOTER //
// ./src/modules/index/views/formEdit/flow/flowConfig/node_circular.js